import { render, staticRenderFns } from "./ViewAllNewsCardGrid.vue?vue&type=template&id=7049f7d0&"
import script from "./ViewAllNewsCardGrid.vue?vue&type=script&lang=js&"
export * from "./ViewAllNewsCardGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports